import React from "react";

// mui components
import { Modal, Stack, Box } from "@mui/material";

// custom components
import Heading2 from "../../typography/heading-02";
import Body1 from "../../typography/body-01";
import PrimaryButton from "../../buttons/primary-button";

// custom animations
import Lottie from "lottie-react";
import errorAnimation from "../../../assets/animations/error.json";

// custom styles
import styles from "./index.module.scss";

export default function LoanAmountCheckModal({ open, handleClose, text }) {
	return (
		<Modal
			open={open}
			aria-labelledby="success modal"
			aria-describedby="success modal"
			disableAutoFocus={true}
			disableEscapeKeyDown={true}
		>
			<Stack
				direction="column"
				justifyContent="center"
				alignItems="center"
				className={styles.modalBodyContainer}
			>
				<Box className={styles.animationContainer}>
					<Lottie animationData={errorAnimation} loop={true} />
				</Box>

				<Stack
					direction="column"
					alignItems="center"
					className={styles.textContainer}
				>
					<Heading2
						text="Loan Amount Exceeds"
						extraClass={styles.successText}
						fontType="semibold"
					/>

					<Body1 text={text} extraClass={styles.successSubText} />
				</Stack>

				<PrimaryButton
					text="Ok"
					onClick={handleClose}
					fullWidth={true}
				/>
			</Stack>
		</Modal>
	);
}
